import { css, SerializedStyles } from '@emotion/react'

/**
 * Applies the passed styles to all immediate child elements
 * @param {CSSInterpolation} styles to apply
 */
export const ifDirectDescendant = (styles: SerializedStyles) => css`
	& > * {
		${styles}
	}
`
